export default "__VITE_ASSET___JUwvJa1__"